import {Accordion, AccordionItem} from "@heroui/react";
import {Icon} from "@iconify/react";
import React from "react";

export default function FaqComponent({title, faqs}: { title: string, faqs: { q: string, a: React.ReactNode }[] }) {
    return (
        <section className="mt-8 lg:mt-18 mb-8 bg-[#EDEEF4]">
            <div className="container mx-auto px-6 lg:px-12 font-inter">

                <div className="text-center mb-12 relative z-20">
                    <h2 className="font-bebas text-[clamp(40px,8vw,56px)] leading-tight mb-4 max-md:mb-2 text-[#1F2022] uppercase">
                        {title}
                    </h2>
                </div>

                <Accordion variant="splitted" selectionMode={"multiple"} className={"gap-4"}>
                    {faqs.map((obj, idx) => (
                        <AccordionItem key={idx} aria-label={obj.q} title={obj.q}
                                       keepContentMounted
                                       className={""}
                                       classNames={{
                                           title: "font-bold",
                                           base:  "data-[open=true]:bg-gray-200"
                                       }}
                                       indicator={({isOpen}) => (isOpen
                                               ? <><Icon icon="material-symbols-light:horizontal-rule" className={'rounded-full text-black bg-white text-[2rem] font-bold p-1 rotate-90'} /></>
                                               : <><Icon icon="material-symbols-light:add" className={' rounded-full text-black bg-slate-100 text-[2rem] font-bold p-1'} /></>
                                       )}
                                       HeadingComponent="h3"
                        >
                            <div>{obj.a}</div>
                        </AccordionItem>
                    ))}
                </Accordion>

            </div>
        </section>
    );
};
